import { FC } from 'react'

import styled from 'styled-components'

type Props = {
  title?: string
  description?: string
}

const Container = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`

const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.darkGrey};
`
const Description = styled(Title)`
  font-weight: 400;
  width: 100%;
`

export const SettingsItem: FC<Props> = (props) => {
  const { title, description } = props
  return (
    <Container>
      <TextWrapper>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </TextWrapper>
    </Container>
  )
}
